import React from "react";
import styled, { css, keyframes } from "styled-components";
import { BASIC_BLACK, BASIC_WHITE } from "../../../constants/colors";

type Props = {
  isShow: boolean;
  showCartPopup: boolean;
  showRecommendedMenuPopup: boolean;
  totalQuantity: number;
  totalPrice: number;
  couponPrice?: number;
  animate: boolean;
  onClick: () => void;
};

export const CartIndicator: React.FC<Props> = ({
  isShow,
  showCartPopup,
  showRecommendedMenuPopup,
  totalQuantity,
  totalPrice,
  couponPrice,
  animate,
  onClick,
}) => {
  return (
    <CartIndicatorContainer $isShow={isShow} onClick={onClick}>
      <CartIndicatorWrapper $animate={animate}>
        <CartContent>
          <Quantity>{totalQuantity}点</Quantity>

          <PriceContainer>
            <Price $strikeThrough={!!couponPrice}>
              ¥{totalPrice.toLocaleString()}
            </Price>

            {couponPrice && (
              <Price $couponPrice>¥{couponPrice.toLocaleString()}</Price>
            )}
          </PriceContainer>
        </CartContent>

        {showCartPopup || showRecommendedMenuPopup ? (
          <Text>ご注文の確認</Text>
        ) : (
          <Text>カートを確認</Text>
        )}
      </CartIndicatorWrapper>
    </CartIndicatorContainer>
  );
};

const CartIndicatorContainer = styled.div<{ $isShow: boolean }>`
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1001;
  width: 100%;
  padding: 0 10px;
  cursor: pointer;
  transition: all 0.5s ease-out;
  transform: ${({ $isShow }) =>
    $isShow ? "translate(0, 0)" : "translate(0, 150px)"};
`;

const bounce = keyframes`
  0% {
    transform: translate(0, 0px) scale(1,1);
    background-color: #000000;
  }
  50% {
    transform: translate(0, -20px) scale(1,1);
    background-color: #999999;
  }
  100% {
    transform: translate(0, 0px) scale(1,1);
    background-color: #000000;
  }
`;

const CartIndicatorWrapper = styled.div<{ $animate: boolean }>`
  ${({ $animate }) =>
    $animate &&
    css`
      animation: ${bounce} 0.5s ease-in-out 0.5s 1 alternate none running;
    `}
  max-width: 768px;
  cursor: pointer;
  background-color: ${BASIC_BLACK};
  color: ${BASIC_WHITE};
  margin: 0 auto 14px auto;
  padding: 9px 20px;
  display: flex;
  flex-direction: row;
  text-align: left;
  border-radius: 8px;
`;

const Quantity = styled.div`
  margin-right: 12px;
  padding: 10px 0;
`;

const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 16px;
  font-weight: 500;
  line-height: 1em;
  gap: 5px;
`;

const Price = styled.div<{ $strikeThrough?: boolean; $couponPrice?: boolean }>`
  ${({ $strikeThrough }) => $strikeThrough && "text-decoration: line-through;"}
  ${({ $couponPrice }) => $couponPrice && "color: #E66231;"}
`;

const Text = styled.div`
  padding: 10px 0;
`;

const CartContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 1em;
`;
